import { useVariant } from "../../context/VariantContext";
import { ABOUT, IMAGES, STATS } from "../../data/content";
import { Reveal } from "./Reveal";

const SectionEyebrow = ({ children, index }) => {
  const { variant } = useVariant();
  return (
    <p
      className={`font-accent text-[11px] uppercase tracking-[0.3em] ${
        variant === "editorial" ? "italic" : ""
      }`}
      style={{ color: "var(--accent)" }}
    >
      {index && <span className="mr-3 text-[color:var(--text-2)]">{index}</span>}
      {children}
    </p>
  );
};

export const About = () => {
  const { variant } = useVariant();
  return (
    <section
      id="about"
      data-testid="about"
      className="relative border-t px-6 py-28 lg:px-10 lg:py-36"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionEyebrow index="01">About</SectionEyebrow>
            <h2 className="font-head mt-6 text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
              {ABOUT.lead}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div
              className="mt-10 overflow-hidden border"
              style={{ borderColor: "var(--border)", borderRadius: "var(--radius-tok)" }}
            >
              <img
                src={IMAGES.atelier}
                alt="Craftsmanship and materials inspection"
                className="aspect-[5/4] w-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.1}>
            {ABOUT.body.map((p, i) => (
              <p
                key={i}
                className={`mb-6 text-base leading-relaxed text-[color:var(--text-2)] sm:text-[17px] ${
                  variant === "editorial" && i === 0 ? "dropcap" : ""
                }`}
              >
                {p}
              </p>
            ))}
          </Reveal>
        </div>
      </div>

      {/* Stats */}
      <div
        className="mx-auto mt-24 grid max-w-7xl grid-cols-2 gap-px border lg:grid-cols-4"
        style={{ borderColor: "var(--border)", background: "var(--border)" }}
      >
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div
              className="flex h-full flex-col justify-center px-6 py-10"
              style={{ background: "var(--bg)" }}
            >
              <p
                className={`font-head text-4xl text-[color:var(--text)] sm:text-5xl ${
                  variant === "swiss" ? "font-black tracking-tighter" : ""
                }`}
              >
                {s.value}
              </p>
              <p className="mt-3 text-xs leading-relaxed uppercase tracking-[0.14em] text-[color:var(--text-2)]">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export { SectionEyebrow };
